module.exports = __webpack_public_path__ + "static/media/other certificate.d4584ae9.svg";